import {GET, POST} from "@/services/gateway";

const list = ({pagination, search, filter}) => {
  return POST('google/seat/classroom/list', {pagination, search, filter});
}

const getStatus = () => {
  return GET('google/seat/classroom/status');
}

const refresh = () => {
  return GET('google/seat/classroom/refresh');
}

const backupAll = () => {
  return GET('google/classroom/backup/all')
}

const backupAllActiveSeats = () => {
  return GET('google/seat/classroom/backup/active-seats')
}

const protectAll = () => {
  return POST('google/seat/classroom/protect');
}

const unprotectAll = () => {
  return POST('google/seat/classroom/unprotect');
}

const changeStatus = ({status, id}) => {
  return POST('google/seat/classroom/status/change', {status, id});
}

const exportSnapshot = (filter, search, pagination) => {
  const currentDate = new Date();

  return POST('google/seat/classroom/export', {
    filter,
    search,
    pagination,
    TimeZoneOffset: currentDate.getTimezoneOffset()
  })
}

export {
  list,
  refresh,
  getStatus,
  protectAll,
  unprotectAll,
  backupAll,
  backupAllActiveSeats,
  changeStatus,
  exportSnapshot
}
